import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../form/button/button';
import { routes } from '../../../../../config/routes';
import { TariffFeatures } from '../../../../web/tariff/features/tariff-features';

export const OffBoardingStep1: React.FC = observer(() => {
    const { t } = useTranslation();

    const premiumFeatures = [
        t('blocks.pricing.premium.features.portfolios'),
        t('blocks.pricing.premium.features.trades'),
        t('blocks.pricing.premium.features.dashboard'),
        t('blocks.pricing.premium.features.importTrade'),
        t('blocks.pricing.premium.features.taxReport'),
        t('blocks.pricing.premium.features.dividends'),
        t('blocks.pricing.premium.features.profitCompareWithIndex'),
        t('blocks.pricing.premium.features.investown'),
        t('blocks.pricing.premium.features.personalAssets'),
        t('blocks.pricing.premium.features.leaderboard'),
        t('blocks.pricing.premium.features.insideValue'),
        t('blocks.pricing.premium.features.priceAlert'),
    ];

    return (
        <>
            <div className="[--tariff-color-light:rgb(var(--color-positive-rgb)/0.24)] [--tariff-color:rgb(var(--color-positive-rgb))] w-full rounded-[2.4rem] border border-border bg-transparent p-medium text-[var(--tariff-color)]">
                <TariffFeatures data={premiumFeatures} />
                <div className="mt-medium">
                    <Button
                        href={routes.web.pricing}
                        variant="purple"
                        shadow
                        gradient
                        block
                        size={{ xs: 'vsmall', md: 'medium' }}
                    >
                        {t('dialogs.offboarding.step1.compareTariffs')}
                    </Button>
                </div>
            </div>
        </>
    );
});
